export default __webpack_public_path__ + "static/media/logo2-nobg.2e1cc94a.png";